import axios from "@/plugins/axios";

let url = (data) => "/api/console/mes/reports/${process}/${planDate}/head".interpolate(data);

export const head = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};

export default head;
